import request from '@/utils/request'

export function getCompanies(size, page, find) {
  return request({
    url: `/general/companies`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function getCompanyById(id) {
  return request({
    url: `/general/companies/id/${id}`,
    method: 'get'
  })
}

export function createCompanies(data) {
  return request({
    url: `/general/companies/create`,
    method: 'post',
    data
  })
}

export function updateCompanies(id, data) {
  return request({
    url: `/general/companies/id/${id}`,
    method: 'put',
    data
  })
}

export function removeCompanies(id) {
  return request({
    url: `/general/companies/id/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/company.js